import { Button, message, Modal } from "antd";
import classes from "./EditManagerActions.module.css";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { useState } from "react";
import {
  useArchiveManagerMutation,
  useBlockManagerMutation,
} from "../../../../../store/api/listManager.api";
import { useDispatch } from "react-redux";
import {
  archiveManager,
  blockManager,
} from "../../../../../store/slice/adminManagerSlice/adminManagerSlice";

export const EditManagerActions = () => {
  const dispatch = useDispatch();

  const [blockTrigger, { isLoading: blockManagerLoading }] =
    useBlockManagerMutation();

  const [archiveTrigger, { isLoading: archiveManagerLoading }] =
    useArchiveManagerMutation();

  const currentManagerInfo = useAppSelector(
    (state) => state.adminManagerInfoSlice.currentManager,
  );

  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [blockModalOpen, setBlockModalOpen] = useState(false);

  const handleOkBlockModal = async () => {
    if (currentManagerInfo) {
      try {
        await blockTrigger({ managerId: currentManagerInfo.id }).unwrap();
        message.success("Менеджер заблокирован");
        dispatch(blockManager());
      } catch (e: any) {
        if (typeof e.data.message === "string") {
          message.error(e.data.message);
        } else {
          message.error("Произошла ошибка");
        }
      }
    }
  };

  const handleOkArchiveModal = async () => {
    if (currentManagerInfo) {
      try {
        await archiveTrigger({
          manager_id: currentManagerInfo.id,
          is_enabled: false,
        }).unwrap();
        message.success("Менеджер отправлен в архив");
        dispatch(archiveManager());
      } catch (e: any) {
        if (typeof e.data.message === "string") {
          message.error(e.data.message);
        } else {
          message.error("Произошла ошибка");
        }
      }
    }
  };

  const isAvaiableForArchieve =
    !currentManagerInfo?.agents.length &&
    !currentManagerInfo?.clients?.length &&
    currentManagerInfo?.is_enabled;

  return (
    <>
      <div className={classes.infoActions}>
        {!currentManagerInfo?.is_banned && (
          <Button
            onClick={() => {
              setBlockModalOpen(true);
            }}
            className={classes.infoButton}
            type="link"
          >
            Заблокировать менеджера
          </Button>
        )}

        {isAvaiableForArchieve && (
          <Button
            onClick={() => {
              setArchiveModalOpen(true);
            }}
            className={classes.infoButton}
            type="link"
          >
            Направить в архив
          </Button>
        )}
      </div>

      {isAvaiableForArchieve && (
        <Modal
          onCancel={() => {
            setArchiveModalOpen(false);
          }}
          open={archiveModalOpen}
          onOk={handleOkArchiveModal}
          okButtonProps={{
            loading: archiveManagerLoading,
            disabled: archiveManagerLoading,
          }}
        >
          <>Менеджер будет отправлен в архив.</>
        </Modal>
      )}

      {!currentManagerInfo?.is_banned && (
        <Modal
          onCancel={() => {
            setBlockModalOpen(false);
          }}
          onOk={handleOkBlockModal}
          open={blockModalOpen}
          okButtonProps={{
            loading: blockManagerLoading,
            disabled: blockManagerLoading,
          }}
        >
          <>Менеджер будет заблокирован.</>
        </Modal>
      )}
    </>
  );
};
